<template>
  <div>
    <div class="detial-cont-title">审批轨迹</div>
    <blank height="1"> </blank>
    <div class="detial-cont-view">
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="getHighLine.formDTOList"
      >
        <!-- <template slot="fieldValue1" slot-scope="text, record">
          <div class="check-icons" v-if="record.fieldValue1 === '1'">
            <a-icon type="check" />同意
          </div>
          <div class="close-icons" v-if="record.fieldValue1 === '2'">
            <a-icon type="close" />不同意
          </div>
        </template> -->
      </a-table>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: '时间',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true
  },
  {
    title: '任务节点',
    dataIndex: 'taskName',
    key: 'taskName',
    ellipsis: true
  },
  {
    title: '责任人',
    dataIndex: 'dutyOfficerStr',
    key: 'dutyOfficerStr',
    ellipsis: true
  },
  {
    title: '意见',
    dataIndex: 'fieldValue1',
    key: 'fieldValue1'
  },
  {
    title: '批示',
    dataIndex: 'fieldValue2',
    key: 'fieldValue2'
  }
]
export default {
  props: ['getHighLine'],
  data() {
    return {
      columns,
      data: []
    }
  }
}
</script>
<style scoped lang="scss">
.detial-cont-title {
  background: #fff;
  height: 55px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 55px;
  text-align: left;
  // padding-left: 32px;
}
.detial-cont-view {
  background: #fff;
  // padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.detial-bottom {
  height: 56px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.check-icons,
.close-icons {
  font-weight: 700;
}
.check-icons {
  color: green;
}
.close-icons {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/views/FixedAssets/components/approvalTrack.vue